import AwList from 'viewmodel/AwListViewModel';
import SearchResultsCell from 'viewmodel/SearchResultsCellViewModel';
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import { get } from 'lodash';
import appCtxSvc from 'js/appCtxService';

export const searchResultsListFunction = (props) => {
    const viewModel = props.viewModel;
    const queryString = get(viewModel, 'data.query', '');
    const accId = props.accsessionid;
    const hClass = 'des-search-results-info';
    if (viewModel.data.totalCount === 0) {
        viewModel.dataProviders.searchResultsListDataProvider.vmCollectionObj.vmCollection.loadedVMObjects = [];
    }
    let showing = get(props, 'i18n.showing', '');
    showing = showing.replace('{0}', get(viewModel, 'data.totalCount', 0));
    showing = showing.replace('{1}', queryString);
    const hasCommands = props.hideCommands ==='true' ? 'false' : 'true';
    appCtxSvc.registerCtx( 'showSearchResultsCommands', hasCommands === 'true' );
    if (queryString.length > 0) {
        if(window.ixEnabled === "true") {
            return (
                <AwPanel className='search-results-acc-ix-brand-search-results-panel'>
                    <AwPanelBody>
                        {!viewModel.dataProviders.searchResultsListDataProvider.vmCollectionObj.fetching &&
                            <h5 class={hClass}>{showing}</h5>
                        }
                        <AwList dataprovider={viewModel.dataProviders.searchResultsListDataProvider} hasFloatingCellCommands={hasCommands}>
                            <SearchResultsCell vmo='item' accsessionid={accId} ></SearchResultsCell>
                        </AwList>
                    </AwPanelBody>
                </AwPanel>
            );
        } else {
            return (
                <AwPanel className='aw-layout-full'>
                    <AwPanelBody>
                        {!viewModel.dataProviders.searchResultsListDataProvider.vmCollectionObj.fetching &&
                            <h5 class={hClass}>{showing}</h5>
                        }
                        <AwList dataprovider={viewModel.dataProviders.searchResultsListDataProvider} hasFloatingCellCommands={hasCommands}>
                            <SearchResultsCell vmo='item' accsessionid={accId} ></SearchResultsCell>
                        </AwList>
                    </AwPanelBody>
                </AwPanel>
            );
        }
    }
    return null;
};

export const onMountResultListFunction = () => {
    handleIxBranding();
};

let popupObserver = null;

export function handleIxBranding() {
    if (!popupObserver) {
        popupObserver = new MutationObserver(() => {
            const ixEnabled = window.ixEnabled;

            const resultListInfo = document.querySelector('.des-search-results-info');
            if(resultListInfo) {
                if (ixEnabled === "true" || ixEnabled === true) {
                    resultListInfo.classList.add('search-results-acc-ix-brand-search-results-info');
                } else {
                    resultListInfo.classList.remove('search-results-acc-ix-brand-search-results-info');
                }
            }
            
            const popupUnorderedListElement = document.querySelector('.aw-widgets-cellListWidget.sw-column.flex-shrink');
            if (popupUnorderedListElement) {
                if (ixEnabled === "true" || ixEnabled === true) {
                    popupUnorderedListElement.classList.add('search-box-acc-ix-brand-dropdown-item');
                } else {
                    popupUnorderedListElement.classList.remove('search-box-acc-ix-brand-dropdown-item');
                }
            }
        });

        popupObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Change the style of des-search-results-as-list ACC

        const searchResultsPanelElement = document.querySelector('.des-search-results-as-list');
        if(searchResultsPanelElement) {
            if(window.ixEnabled === "true" || window.ixEnabled === true) {
                searchResultsPanelElement.classList.add('search-results-acc-ix-brand-search-results-panel');
            } else {
                searchResultsPanelElement.classList.remove('search-results-acc-ix-brand-search-results-panel');
            }
        }
    }

};
